import { DITypes } from "@/core/@types/types";
import DownloadFileOnBrowser from "@/composables/shared/download/adapters/DownloadFileOnBrowser";
import { IDownloadHandler } from "@/composables/shared/download/handlers/DownloadHandler";
import DownloadPDFFile from "@/composables/shared/download/adapters/DownloadPDFFile";
import DownloadStrategy from "@/composables/shared/download/DownloadStrategy";
import DownloadZIP from "@/composables/shared/download/adapters/DownloadZIP";
import PDFDownloadHandler from "@/composables/shared/download/handlers/PDFDownloadHandler";
import ZIPDownloadHandler from "@/composables/shared/download/handlers/ZIPDownloadHandler";
import {
  IDownload,
  IDownloadOnBrowser
} from "@/composables/shared/download/types";
import { ContainerModule } from "inversify";
import PNGDownloadHandler from "@/composables/shared/download/handlers/PNGDownloadHandler";
import DownloadPNGFile from "@/composables/shared/download/adapters/DownloadPNGFile";
import DownloadPFXFile from "@/composables/shared/download/adapters/DownloadPFXFile";
import PFXDownloadHandler from "@/composables/shared/download/handlers/PFXDownloadHandler";

const downloadContainer = new ContainerModule((bind) => {
  bind<IDownloadOnBrowser>(DITypes.DOWNLOAD_ON_BROWSER)
    .to(DownloadFileOnBrowser)
    .inSingletonScope();
  bind<IDownloadHandler>(PDFDownloadHandler).toSelf().inSingletonScope();
  bind<IDownloadHandler>(ZIPDownloadHandler).toSelf().inSingletonScope();
  bind<IDownloadHandler>(PNGDownloadHandler).toSelf().inSingletonScope();
  bind<IDownloadHandler>(PFXDownloadHandler).toSelf().inSingletonScope();
  bind<IDownload>(DITypes.DOWNLOAD_PDF).to(DownloadPDFFile).inSingletonScope();
  bind<IDownload>(DITypes.DOWNLOAD_ZIP).to(DownloadZIP).inSingletonScope();
  bind<IDownload>(DITypes.DOWNLOAD_PNG).to(DownloadPNGFile).inSingletonScope();
  bind<IDownload>(DITypes.DOWNLOAD_PFX).to(DownloadPFXFile).inSingletonScope();
  bind(DownloadStrategy).toSelf().inSingletonScope();
});

export { downloadContainer };
